var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseSearch = function SvgCloseSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".close_search_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_search_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close_search_svg__st0",
    d: "m20.4 20.4 7.2 7.2M27.6 20.4l-7.2 7.2"
  }))));
};
export default SvgCloseSearch;